<script setup></script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" class="min-w-[16px]" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.4795 5.84863C11.3162 8.56834 12.0515 13.8284 12.0515 13.8284H3.94947C3.94947 13.8284 4.68675 8.56834 3.52344 5.84863"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.2941 8.2885L15.0003 7.43509L13.7053 3.75543C13.5799 3.39943 13.3641 3.08215 13.0791 2.83475C12.7941 2.58736 12.4496 2.41835 12.0795 2.34433L10.3565 2C10.2586 3.46646 9.24716 4.6237 8.00013 4.6237C6.7531 4.6237 5.7417 3.46646 5.6438 2L3.92077 2.34501C3.55075 2.41897 3.20631 2.58787 2.92128 2.83514C2.63625 3.08241 2.42042 3.39955 2.29497 3.75543L1 7.43509L2.70615 8.2885"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M8.30005 11.4028V6.90234H6.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>

<style scoped lang="scss"></style>
